<template>
  <div class="image_div" :style="{ 'max-width': `${size}px` }">
    <b-img class="image" :class="{ 'clickable': can_click_image }" loading="lazy" thumbnail fluid :src="tumbImageUrl" :style="{ 'max-height': `${size}px` }" @click="$emit('image_click')"/>
    <a href="" class="download_btn" @click.prevent="" @click="download_image()"><i
        class="mx-1 fa fa-download fa-lg" /></a>
    <div class="option_btn">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  props: {
    size: {
      type: Number,
      required: false,
      default: 300,
    },
    file: {
      value: Object,
      required: true,
    },
    set_id: {
      type: Number,
      required: true,
    },
    can_click_image: {
      type: Boolean,
      required: false,
      default: false,
    },
    image_type: {
      type: String,
      required: false,
      default: 'sample',
    },
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['fileUrl']),
    imageUrl() {
      return this.fileUrl(this.file.id, this.set_id, this.image_type);
    },
    tumbImageUrl() {
      return `${this.imageUrl}&cvt=thumb_large`;
    },
  },
  methods: {
    download_image() {
      const name = `${this.image_type}_ss${this.set_id}_s${this.file.sample_id}_f${this.file.id}`;

      fetch(this.imageUrl, {
        mode: 'no-cors',
      })
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.download = name;
          a.href = blobUrl;
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },
  },
};
</script>
<style lang=scss>
.image_div {
  position: relative;
  display: inline-block;
  width: 100%;
}

.image_div:hover .download_btn {
  display: block;
}

.image_div:hover .option_btn {
  display: block;
}

.image_div .download_btn {
  position: absolute;
  bottom: 2px;
  right: 2px;
  display: none;
}

.option_btn {
  position: absolute;
  display: none;
  bottom: 2px;
  left: 6px;
}

.image {
  width: 100%;
  aspect-ratio: 1;
  object-position: center;
  object-fit: contain;

  &.img-thumbnail {
    padding: 0;
  }

  &.clickable {
    cursor: pointer;
  }
}

.download_btn {
  background-color: rgba(200, 200, 200, 0.7);
  padding: 1px 0 0 0;
  border-radius: 5px;
}
</style>
